import PlayerNoIMA from './video/RmpVastPlayer';
import PlayerIMA from './video/IMAPlayer';
import CTAScreen from "./components/CTAScreen";
import SafeCountdown from "./components/SafeCountdown";
import Fallback from "./components/Fallback";

import {IStore, State, connect, actions} from "./store";
import { Stats } from "webpack";

export const TypePreroll: React.FC<IStore> = ({ generalState, videoIMAFailed }) => {
  const Player = videoIMAFailed ? PlayerNoIMA : PlayerIMA;

  if (generalState === State.FINISH) {
    return <></>;
  }

  return (
    <>
      { generalState === State.FALLBACK ? <Fallback /> : null }
      { generalState !== State.FALLBACK ? <CTAScreen><Player /></CTAScreen> : null }
      { generalState !== State.CTA && <SafeCountdown /> }
    </>
  );
};

export default connect(['generalState', 'videoIMAFailed'], actions)(TypePreroll);

